module.exports = __webpack_public_path__ + "07d7db1e3b97ead09b3844ac44dc2302.svg";